import React, { useEffect, useState } from "react";
import { Button, DatePicker, Form, Input } from "antd";
import { ContainerModal } from "../../container/ContainerModal";
import { typeForDetailsProyect } from "../../../types/typeModalDetailsProject";

const dateFormat = "YYYY/MM/DD";

export const FormCancelProject = ({ dataForm = [], disabled = false, title = "", editFormForProjectDetails, closeModalDetails }) => {

	const [form] = Form.useForm();

	const [loading, setLoading] = useState(false);

	useEffect(() => {
		form.setFieldsValue(dataForm);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const finishForm = async ({ canceledAt, ...values }) => {
		if (disabled) {
			closeModalDetails();
			return;
		}

		setLoading(true);

        await editFormForProjectDetails(
            typeForDetailsProyect.continueCancelarProyect,
            {
			...values,
			canceledAt: canceledAt.format("YYYY-MM-DD"),
            },
            {
                nextModal: typeForDetailsProyect.concluedProject
            }
        );
        setLoading(false);

	};

	return (
		<div className="fixed top-0 left-0 w-full h-full z-50 bg-black bg-opacity-45 flex justify-center items-center">
			<ContainerModal
				title={title}
				actionButton={() => {
					closeModalDetails();
				}}
				className={"w-[500px]"}
			>
				<Form form={form} onFinish={finishForm} className="w-full flex flex-col gap-4">
					{!disabled && (
						<div className="flex justify-center items-center text-[#E4404B]">
							<p>¿Estás seguro de cancelar el proyecto?</p>
						</div>
					)}
					<div className="flex  gap-4 items-center justify-center">
						<p>
							<span className="text-[#E4404B]">*</span>Fecha que se cancela
						</p>
						<Form.Item
							name={"canceledAt"}
							className="h-[10px]"
							rules={[
								{
									required: !disabled,
									message: "Necesita una fecha",
								},
							]}
						>
							<DatePicker format={dateFormat} size="small" disabled={disabled} />
						</Form.Item>
					</div>
					<div className="flex flex-col gap-2">
						<p>Comentarios:</p>
						<Form.Item name="comment" className="h-[110px]">
							<Input.TextArea
								placeholder="Comentario"
								autoSize={{
									minRows: 5,
									maxRows: 5,
								}}
								showCount={false}
								disabled={disabled}
							/>
						</Form.Item>
					</div>
					<div className="w-full h-[40px] overflow-hidden flex justify-center gap-4">
						<Button htmlType="button" onClick={closeModalDetails}>
							Cancelar
						</Button>
						<Button type="primary" htmlType="submit" className="bg-primaryTwo" loading={loading}>
							{disabled ? "Cerrar" : "Aceptar"}
						</Button>
					</div>
				</Form>
			</ContainerModal>
		</div>
	);
};
